export default __webpack_public_path__ + "static/media/ic_convert_down.74b7eb02.svg";